import styled from 'styled-components'
import { media } from 'Config/styled'

export const BigTitle = styled.div`
  margin: ${props => props.margin};
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 2rem;
  text-align: ${props => props.textAlign || null};

  ${media('lg')} {
    font-size: 20px;
    margin-bottom: 16px;
  }
`
